/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { PersonalizationResponse, UserPersonalizationRequest } from '../../types.tsx';

const getPersonalizationUserTraitsUrl = (userId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;

export const fetchUserPersonalization = async ({
	userId,
}: UserPersonalizationRequest): Promise<PersonalizationResponse['attributes']> => {
	if (!userId) throw new Error('empty userId');

	const { attributes } = await fetchJson(getPersonalizationUserTraitsUrl(userId), {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			'x-atlassian-mau-ignore': 'true',
		},
	});

	return attributes;
};
